// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productDetailsSummaryStyles } from "@turnerBlueprint/App/Components/ProductDetails/ProductDetailsSummary";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { ellipsis } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

productDetailsSummaryStyles.container = {
    css: css`
        align-items: center;
        justify-content: space-between;
        display: flex;
        height: 100%;
    `,
};

productDetailsSummaryStyles.leftSection = {
    css: css`
        display: flex;
        gap: 16px;
    `,
};

productDetailsSummaryStyles.rightSection = {
    css: css`
        min-width: 347px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        row-gap: 12px;
    `,
};

productDetailsSummaryStyles.productImage = {
    width: "80px",
    height: "80px",
    css: css`
        object-fit: contain;
    `,
};

productDetailsSummaryStyles.brandStyles = {
    nameLink: {
        typographyProps: {
            weight: fontConfig.weight.bold,
            color: "text.link",
            size: 12,
            css: css`
                && {
                    line-height: 13px;
                    margin-bottom: 4px;
                    display: block;
                }
            `,
        },
    },
};

productDetailsSummaryStyles.productTitle = {
    size: 14,
    lineHeight: "16px",
    weight: fontConfig.weight.bold,
    css: css`
        ${ellipsis(1)};
    `,
};

productDetailsSummaryStyles.titleWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        max-width: 560px;
    `,
};

productDetailsSummaryStyles.numbersAvailablityWrapper = {
    css: css`
        margin-top: 10px;
        display: flex;
        column-gap: 24px;
    `,
};

productDetailsSummaryStyles.numbersWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 4px;
        width: 265px;
    `,
};

productDetailsSummaryStyles.labelText = {
    size: 12,
    lineHeight: "13px",
    weight: fontConfig.weight.bold,
    css: css`
        margin-right: 4px;
    `,
};

productDetailsSummaryStyles.valueText = {
    size: 12,
    lineHeight: "13px",
};

productDetailsSummaryStyles.availability = {
    messageGridItem: {
        width: 12,
    },
};

productDetailsSummaryStyles.productPrice = {
    price: {
        priceText: {
            variant: "h3",
            forwardAs: "p",
            css: css`
                &&& {
                    margin: 0;
                    line-height: 28px;
                }
            `,
        },
    },
};
